import React from 'react';
import { SparklesIcon, UserIcon, EnvelopeIcon, BookOpenIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';

export default function FinalThoughts() {
  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Final Thoughts"
        icon={<SparklesIcon className="h-7 w-7 text-primary-light" />}
        heading="Reflections and next steps"
      >
        <PlaybookCard>
          <p className="text-lg text-gray-200">
            Using this playbook offers you a comprehensive framework for handling mistakes effectively. Remember, the goal is not just to fix the immediate issue, but to create a culture of transparency, learning, and continuous improvement.
          </p>
        </PlaybookCard>

       

        
      </PlaybookSection>
    </div>
  );
} 